// extracted by mini-css-extract-plugin
export default {"current":"bm_kT","update":"bm_kV"};